import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { renderRawHTML } from 'utils/formatters/html';
import { useTranslation } from 'react-i18next';
import marked from 'marked';
import { LocaleContext } from 'providers/locale-settings-context';
import { sluggify } from '../../../utils/localization/utils';

const renderer = new marked.Renderer();

renderer.link = function (href, title, text) {
  return '<a target="_blank" href="'.concat(
    href,
    '" title="',
    title,
    '">',
    text,
    '</a>',
  );
};

const Comment = ({
  comment: {
    author,
    timestamp,
    message,
    reasonCode,
    reasonDescription,
    meta = null,
  },
}) => {
  const { t } = useTranslation();
  const { formatDateTimeVerbal } = useContext(LocaleContext);
  let actualMessage = message;
  if (meta) {
    const { translations = [] } = meta;
    actualMessage = translations.reduce(
      (acc, { slug, value, localizeValue }) => {
        acc += `${t(slug, {
          value: localizeValue ? t(sluggify(value)) : value,
        })} \n`;
        return acc;
      },
      '',
    );
  }
  try {
    actualMessage = renderRawHTML(
      marked(decodeURI(actualMessage), { renderer: renderer }),
    );
  } catch (e) {
    try {
      actualMessage = unescape(actualMessage);
    } catch (e) {
      actualMessage = t('ISSUE_DECODING_COMMENT');
    }
  }

  return (
    <div className="border border-solid border-grey-lightest shadow p-4 bg-white">
      <p className="mb-2 text-xs">
        <span className="font-bold text-grey-darker">{author}</span>
        <span className="mx-1">&middot;</span>
        <span className="text-grey-dark">
          {formatDateTimeVerbal(timestamp)}
        </span>
      </p>
      <div className="break-words whitespace-pre-wrap text-grey-darker">
        {actualMessage}
      </div>
      {reasonCode && reasonCode.length && (
        <p className="text-grey-darker">
          {t('REASON_WITH_VALUE', { value: t(sluggify(reasonCode)) })}
        </p>
      )}
      {reasonDescription && reasonDescription.length && (
        <p className="text-grey-darker">
          {t('DESCRIPTION_WITH_VALUE', { value: reasonDescription })}
        </p>
      )}
    </div>
  );
};

Comment.propTypes = {
  comment: PropTypes.shape({
    author: PropTypes.string,
    timestamp: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
};

export default Comment;
